import { FC } from "react";
import CreateCentres from "../../../Centres";

const Centres: FC = () => {
  return(
    <>
      <CreateCentres />
    </>
  )
}

export default Centres;